// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.JlpEy1sWNPMduY2U_eDR{margin:0 24px 24px}.CdlvwJAjpzEsl0JwcZzN{margin:0 24px 16px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"seatsInput": `JlpEy1sWNPMduY2U_eDR`,
	"priceInfo": `CdlvwJAjpzEsl0JwcZzN`
};
export default ___CSS_LOADER_EXPORT___;
